import graphql__bdfbfa693efb9a62db72 from "./__generated__/PrivacyCookieConsent_platform.graphql.js";import { useState, useCallback, useRef } from "react";
import { graphql, useFragment } from "react-relay";
import { useDispatch } from "react-redux";
import { defineMessages } from "react-intl";
import { CSSTransition } from "react-transition-group";

import Button from "../Buttons/Button";
import ButtonLink from "../Buttons/ButtonLink";
import { Desktop, NonDesktop } from "../Utils/ResponsiveQueries";
import { useFormatMessage } from "../Intl/Context";
import { useRoutesContext } from "../Routes/RoutesContext";
import { useDeferredEffect } from "../Utils/useDeferredEffect";

import { storeViewerCookiesConsentment } from "../../mutations/StoreViewerCookiesConsentmentMutation";
import { updateViewer } from "../../reducers/viewer";

const PrivacyCookieConsent = props => {
  const platform = useFragment(PrivacyCookieConsent_platform, props.platform);
  const { cookieConsentBannerReadMoreTargetPageSlug } = platform || {};

  const nodeRef = useRef();

  const dispatch = useDispatch();
  const handleCookiesConsentmentClicked = useCallback(
    accepts => {
      storeViewerCookiesConsentment(accepts, ({ storeViewerCookiesConsentment }) =>
        dispatch(updateViewer(storeViewerCookiesConsentment.viewer))
      );

      setShowBanner(false);
    },
    [dispatch]
  );

  const [showBanner, setShowBanner] = useState(false);

  const t = useFormatMessage();
  const message = t(intlMessages.message);
  const accept = t(intlMessages.accept);
  const refuse = t(intlMessages.refuse);
  const readMore = t(intlMessages.readMore);

  const { pathFor } = useRoutesContext();
  const privacyPolicyPagePath = pathFor("page", {
    id: cookieConsentBannerReadMoreTargetPageSlug
  });

  useDeferredEffect(
    () => {
      setShowBanner(true);
    },
    [],
    { wait: 2000 }
  );

  const actions = [
    <Button
      key="accept"
      className="cookie-consent-accept-btn btn btn-primary btn-md margin-right-sm"
      onClick={() => handleCookiesConsentmentClicked(true)}
      label={accept}
      data-cookies-accept-button
    />,
    <Button
      key="refuse"
      className="cookie-consent-refuse-btn btn btn-md margin-right-sm bg-primary-20 text-primary"
      onClick={() => handleCookiesConsentmentClicked(false)}
      label={refuse}
      data-cookies-refuse-button
    />,
    // Only show the read more button if we could fetch a the slug of the target page
    cookieConsentBannerReadMoreTargetPageSlug && (
      <ButtonLink
        key="readMore"
        className="cookie-consent-refuse-btn btn btn-md text-primary"
        href={privacyPolicyPagePath}
        label={readMore}
        data-cookies-read-more-button
      />
    )
  ];

  return (
    <CSSTransition
      nodeRef={nodeRef}
      classNames="transition-slide-from-bottom"
      timeout={200}
      in={showBanner}
      unmountOnExit
    >
      <div
        ref={nodeRef}
        className="cookie-consent-banner fixed-bottom box-shadow-lg padding-lg bg-primary-inverse clearfix"
      >
        <Desktop>
          <div className="d-flex align-items-center">
            <p
              className="cookie-consent-message flex-1 margin-right-md margin-bottom-none"
              dangerouslySetInnerHTML={{ __html: message }}
            />
            <div className="cookie-consent-actions">{actions}</div>
          </div>
        </Desktop>

        <NonDesktop>
          <p
            className="cookie-consent-message margin-bottom-none"
            dangerouslySetInnerHTML={{ __html: message }}
          />
          <div className="cookie-consent-actions margin-top-md">{actions}</div>
        </NonDesktop>
      </div>
    </CSSTransition>
  );
};

const PrivacyCookieConsent_platform = graphql__bdfbfa693efb9a62db72;

export default PrivacyCookieConsent;

const intlMessages = defineMessages({
  message: {
    id: "cookies.consent.message",
    defaultMessage: `
      Nous utilisons les cookies afin de mesurer et d'analyser la fréquentation
      du site, ainsi que pour la gestion de l'authentification des contributions
      et la sécurité des comptes utilisateurs.
    `
  },
  accept: {
    id: "cookies.consent.accept",
    defaultMessage: "J'accepte"
  },
  refuse: {
    id: "cookies.consent.refuse",
    defaultMessage: "Je refuse"
  },
  readMore: {
    id: "cookies.consent.readMore",
    defaultMessage: "En savoir plus"
  }
});
